import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';
import { resolveScopedStyles } from 'core/utils/styled-jsx';

import Button from '../Button';
import Link from '../Link';

import styles from './index.styl';

/**
 * @author Alexey Rezakov <a.rezakov@rambler-co.ru>
 */
function Tag({
  link,
  sign: Sign,
  children,
  ...props
}) {
  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .link
          text-decoration none
          &:hover
            text-decoration none
      `}</style>
    </scope>
  );

  return (
    <Link to={link} className={scope.wrapClassNames('link')}>
      <style jsx>{`
        .sign
          color ${props.theme.colors.active1}
      `}</style>
      <Button {...props}>
        { Sign && (
          <span className={cx('sign', styles.sign)}>
            {
              typeof Sign === 'function'
                ? <Sign width='18' height='18' />
                : Sign
            }
            &nbsp;
          </span>
        )}
        {children}
      </Button>
      <scope.styles />
    </Link>
  );
}

Tag.propTypes = {
  /** Тип визуального отображения тега */
  type: PropTypes.string,
  /** Размер тега */
  size: PropTypes.string,
  /** Внешняя ссылка */
  link: PropTypes.oneOfType([
    // например на странице рубрики
    PropTypes.string,
    // например на странице поиска
    PropTypes.object,
  ]).isRequired,
  /** Элемент, рендерится внутри тега, совместно с children */
  sign: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
  ]),
  /** @ignore */
  theme: themePropTypes(`
    {
      colors: {
        active1
      },
    }
  `),
};

Tag.defaultProps = {
  type: 'secondary',
  size: 'small',
};

const TagWithHOCs = withTheme(Tag);
TagWithHOCs.displayName = 'Tag';

export { Tag as StorybookComponent };
export default TagWithHOCs;
